import { type JSX, useState } from 'react';

import type {
	actionComponent,
	actionType,
	ICallSection,
	IrightPanelCTA,
	IRightSection,
	IRSAction,
} from '../components/utils/right-panel/utils';

export const useRightPanel = <K extends {}>(): IRightSection<K> => {
	const [title, setTitle] = useState<string | JSX.Element>('');
	const [dataRequestCounter, setDataRequestCounter] = useState<number>(0);
	const [openSection, setOpenSection] = useState<boolean>(() => false);
	const [slug, setSlug] = useState<string>(() => '');
	const [cta, setCTA] = useState<IrightPanelCTA[]>([]);
	const [max, setMax] = useState<boolean>(false);
	const [action, setAction] = useState<IRSAction>({
		type: null,
		component: '',
		id: null,
	});
	const [data, setData] = useState<{
		onRefresh?: () => void;
		[key: string]: any;
	} | null>(null);

	function updateData(data: K | null) {
		setData(data);
	}

	const isView = (type: actionType[], component: actionComponent) => type.includes(action.type) && action.component === component;

	function callSection<T>(arg: ICallSection<T>) {
		const { action, component, title, id, data, slug, cta, max } = arg;
		setAction((prev) => ({
			type: action || prev.type,
			component: component || prev.component,
			id: id || prev.id,
		}));
		setTitle((prev) => title || prev);
		setOpenSection(true);
		setData(data as unknown as K);
		setSlug((prev) => slug || prev);
		setCTA((prev) => cta || prev);
		setMax((prev) => max || prev);
		setCTA([]);
	}

	const closeSection = () => {
		setAction({ component: '', type: null, id: null });
		setOpenSection(false);
		setSlug('');
		setCTA([]);
		setMax(false);
	};

	return {
		closeSection,
		openSection,
		setAction,
		action,
		setTitle,
		title,
		callSection,
		isView,
		data,
		updateData,
		setDataRequestCounter,
		dataRequestCounter,
		slug,
		cta,
		max,
		setMax,
		setCTA,
	};
};
